import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UiComponent } from '@df/ui/ui.component';
@Component({
    selector: 'account-back',
    templateUrl: './account-back.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, RouterLink]
})
export class AccountBackComponent extends UiComponent {
    /**
     * If asynchronous change detection is allowed
     */
    protected acyncCd = false;
    @Input()
    title: string | undefined;
    @Input()
    link: string = '/account';
    @Input()
    aria: string = 'to account';
}
